/** Shared demote confirm copy (Promote panel, Marketing tile, Coverage). */
export const DEMOTE_ASSET_LEAVE_COVERAGE_NOTE =
  "It will leave Coverage and won’t be usable in marketing until it’s accepted again on Promote.";

export const DEMOTE_ASSET_CONFIRM_DESCRIPTION = `Demote this image? ${DEMOTE_ASSET_LEAVE_COVERAGE_NOTE}`;
